import React, { useEffect, useRef, useState } from "react"
// import styles from "./chat.module.css";
// import { AssistantStream } from "openai/lib/AssistantStream"
import sendImage from "../images/messagesendalt.png"
// import { useRouter, usePathname, redirect, useSearchParams } from 'next/navigation';
// import { useNavigate, useLocation, useSearchParams } from 'react-router-dom';
import { useLocation } from "@reach/router"
import { navigate } from "gatsby"
import { RxCross2 } from "react-icons/rx"
// @ts-expect-error - no types for this yet

const useQuery = () => {
  return new URLSearchParams(useLocation().search)
}
const UserMessage = ({ text }) => {
  return (
    <div
      className="user-message"
    //   className={styles.userMessage}
    >
      {text}
    </div>
  )
}
const baseUrlProd = "https://staging.visiomate.com/"
const baseUrlDev = "http://127.0.0.1:5001/"
const ProductCard = ({ product }) => (
  <a href={product?.product_url} target="_blank">
    <div className="shadow-2xl rounded-lg flex flex-col items-center bg-white">
      {/* <img src={product.image} alt={product.title} className={`w-full h-32 object-cover ${styles.pimg}`} /> */}
      <img
        src={product.image}
        alt={product.title}
        className={`w-full h-32 object-cover`}
      />
      <h3 className=" text-sm font-bold my-3 mx-3 text-center">
        {product.title}
      </h3>
      <p className="text-gray-700 text-xs text-center mx-2">
        {product.description}
      </p>
      <p className="text-blue-600 font-semibold my-3">{product.price}</p>
    </div>
  </a>
)

// Function to extract JSON from Markdown and separate text content
const parseMessageContent = message => {
  const jsonRegex = /```json\s*([\s\S]*?)\s*```/ // Regex to find JSON in markdown
  const match = message.match(jsonRegex)

  let textContent = message
  let products = []

  if (match) {
    try {
      products = JSON.parse(match[1]) // Parse JSON
      textContent = message.replace(match[0], "").trim() // Remove JSON from text
    } catch (error) {
      console.error("Error parsing JSON:", error)
    }
  }

  return { textContent, products }
}

const MessageRenderer = ({ message }) => {
  // const { textContent, products } = parseMessageContent(message)

  return (
    <div style={{ marginBlock: ".5rem" }}>
      {/* Render text message first */}
      <p style={{ whiteSpace: "pre-wrap" }}>{message}</p>

      {/* Render product cards if present */}
      {/* {products.length > 0 && (
        <div className="grid grid-cols-2 gap-4 mt-3">
          {products.map((product, index) => (
            <ProductCard key={index} product={product} />
          ))}
        </div>
      )} */}
    </div>
  )
}

const AssistantMessage = ({ text }) => {
  // debugger
  return (
    <div className={` assistantMessage`}>
      {/* <div className={`${styles.assistantMessage} assistantMessage`}> */}
      {/* <Markdown>{text}</Markdown> */}
      <MessageRenderer message={text} />
    </div>
  )
}

const LoadingMessage = () => {
  return (
    <div className={` assistantMessage`}>
      {/* <div className={`${styles.assistantMessage} assistantMessage`}> */}
      <div className="loader"></div>
    </div>
  )
}

const CodeMessage = ({ text }) => {
  return (
    <div
    // className={styles.codeMessage}
    >
      {text.split("\n").map((line, index) => (
        <div key={index}>
          <span>{`${index + 1}. `}</span>
          {line}
        </div>
      ))}
    </div>
  )
}

const Message = ({ role, text }) => {
  console.log({ role, text })
  switch (role) {
    case "user":
      return <UserMessage text={text} />
    case "assistant":
      return <AssistantMessage text={text} />
    case "code":
      return <CodeMessage text={text} />
    case "loading":
      return <LoadingMessage />
    default:
      return null
  }
}

const Chat = ({
  setBotChat,
  functionCallHandler = () => Promise.resolve(""), // default to return empty string
  chatName,
}) => {
  // const navigate = useNavigate();
  const location = useLocation()
  const searchParams = useQuery()
  //   const searchParams = useSearchParams();
  const email = searchParams.get("email")
  const [userInput, setUserInput] = useState("")
  const [messages, setMessages] = useState([])
  const [inputDisabled, setInputDisabled] = useState(true)
  const [threadId, setThreadId] = useState("")
  const [userId, setUserId] = useState();
  const [isLoading, setIsLoading] = useState(true);
  // const [selectedThread, setSelectedThread] = useState();
  const [threads, setThreads] = useState([{
    id: 1,
    threadSample: 'Hi! I am your assistant here. How may i help you.',
    lastMessageDate: '2025-04-30'
  }, {
    id: 2,
    threadSample: 'Hi! I am your assistant here.',
    lastMessageDate: '2025-04-30'
  }])
  //   const router = useRouter();
  //   const pathname = usePathname();

  // automatically scroll to bottom of chat
  const messagesEndRef = useRef(null)
  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }
  useEffect(() => {
    scrollToBottom()
  }, [messages])

  const createThread = async () => {
    setIsLoading(true);
    const res = await fetch(`${baseUrlProd}assistants/threads`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        userId: userId
      }),
    })
    const data = await res.json()
    setThreadId(data.threadId)
    setIsLoading(false);
    const response = await fetch(
      `${baseUrlProd}assistants/threads/${data.threadId}/messages`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          content: "Introduce Yourself",
          userId: userId,
          path: chatName,
        }),
      }
    )
    const assistantResponse = await response.json()
    appendMessage("assistant", assistantResponse.message)
    setInputDisabled(false)
  }

  const randomId = function (length = 6) {
    return Math.random().toString(36).substring(2, length + 2);
  };

  useEffect(() => {
    if (!localStorage.getItem('userId')) {
      let id = randomId();
      localStorage.setItem("userId", id)
      setUserId(id);
    } else {
      let userId = localStorage.getItem('userId');
      setUserId(userId);
    }
  }, [])

  useEffect(() => {
    const getAllThreads = async () => {
      const response = await fetch(
        `${baseUrlProd}assistants/user/threads/${userId}`,
        {
          method: "GET",
        }
      )
      let resp = await response.json();
      console.log({ threads: resp });
      if (resp?.threads?.length) {
        setThreads(resp?.threads);
        setIsLoading(false);
      } else {
        setThreads([])
        setIsLoading(false);
      }
    }
    if (userId) {

      getAllThreads();
    }
  }, [userId])

  const deleteThread = async () => {
    const response = await fetch(
      `${baseUrlProd}assistants/threads/${threadId}`,
      {
        method: "DELETE",
      }
    )
    const deleteThread = await response.json()
    if (deleteThread.deleted) {
      navigate(`/assistants?email=${email}`)
    }
  }


  const fetchMessages = async (tId) => {
    const response = await fetch(
      `${baseUrlProd}assistants/threads/${tId}/messages`,
      {
        method: "GET",
      }
    )
    const threadMessages = await response.json()
    console.log({ threadMessages })
    if (threadMessages?.messages?.length) {
      setThreadId(tId);
      threadMessages?.messages?.slice(1)?.forEach(m => {
        appendMessage(m?.role, m?.content)
      })
      setInputDisabled(false);
    } else {
      setThreadId(tId);
      setInputDisabled(false);
      setMessages([]);
    }
    // Find the first assistant message in the retrieved messages
    // const assistantIntroductionMessage = assistantResponse.data.find(msg => msg.role === 'assistant');

    // if (assistantIntroductionMessage && assistantIntroductionMessage.content.length > 0) {
    // appendMessage("assistant", assistantResponse.message)
    // setInputDisabled(false)
  }


  const sendMessage = async text => {
    const response = await fetch(
      `${baseUrlProd}assistants/threads/${threadId}/messages`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          content: text,
          userId: userId,
          path: chatName,
        }),
      }
    )
    const assistantResponse = await response.json()
    console.log({ initialMessages: assistantResponse })

    // Find the first assistant message in the retrieved messages
    // const assistantIntroductionMessage = assistantResponse.data.find(msg => msg.role === 'assistant');

    // if (assistantIntroductionMessage && assistantIntroductionMessage.content.length > 0) {
    appendMessage("assistant", assistantResponse.message)
    setInputDisabled(false)
  }

  function formatLastMessageTime(timestamp) {
    const messageDate = new Date(timestamp);
    const now = new Date();

    const isToday =
      messageDate.getDate() === now.getDate() &&
      messageDate.getMonth() === now.getMonth() &&
      messageDate.getFullYear() === now.getFullYear();

    if (isToday) {
      // Return time in 24-hour format (HH:mm)
      return messageDate.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false,
      });
    } else {
      // Return date only (e.g., 28/04/2025)
      return messageDate.toLocaleDateString("en-GB");
    }
  }

  const handleDeleteThread = e => {
    e.preventDefault()
    setInputDisabled(true)
    deleteThread()
  }

  const handleSubmit = e => {
    e.preventDefault()
    if (!userInput.trim()) return
    sendMessage(userInput)
    setMessages(prevMessages => [
      ...prevMessages,
      { role: "user", text: userInput },
    ])
    setUserInput("")
    setInputDisabled(true)
    scrollToBottom()
  }



  /*
    =======================
    === Utility Helpers ===
    =======================
  */

  const appendToLastMessage = text => {
    setMessages(prevMessages => {
      const lastMessage = prevMessages[prevMessages.length - 1]
      const updatedLastMessage = {
        ...lastMessage,
        text: lastMessage.text + text,
      }
      return [...prevMessages.slice(0, -1), updatedLastMessage]
    })
  }

  const appendMessage = (role, text) => {
    setMessages(prevMessages => [...prevMessages, { role, text }])
  }

  return (
    <div className="chat-div-cover">
      <div
        className="chatHeader"
      >
        <span className="chat">
          <svg viewBox="0 0 32 32" className="chaticon" xmlns="http://www.w3.org/2000/svg"><defs></defs><title /><g data-name="Layer 25" id="Layer_25"><path class="cls-1" d="M24,22a1,1,0,0,1-.64-.23L18.84,18H17A8,8,0,0,1,17,2h6a8,8,0,0,1,2,15.74V21a1,1,0,0,1-.58.91A1,1,0,0,1,24,22ZM17,4a6,6,0,0,0,0,12h2.2a1,1,0,0,1,.64.23L23,18.86V16.92a1,1,0,0,1,.86-1A6,6,0,0,0,23,4Z" /><rect class="cls-1" height="2" width="2" x="19" y="9" /><rect class="cls-1" height="2" width="2" x="14" y="9" /><rect class="cls-1" height="2" width="2" x="24" y="9" /><path class="cls-1" d="M8,30a1,1,0,0,1-.42-.09A1,1,0,0,1,7,29V25.74a8,8,0,0,1-1.28-15,1,1,0,1,1,.82,1.82,6,6,0,0,0,1.6,11.4,1,1,0,0,1,.86,1v1.94l3.16-2.63A1,1,0,0,1,12.8,24H15a5.94,5.94,0,0,0,4.29-1.82,1,1,0,0,1,1.44,1.4A8,8,0,0,1,15,26H13.16L8.64,29.77A1,1,0,0,1,8,30Z" /></g></svg>
          Chat</span>
        <span className="title">Talk with Visiomate's Team! 😀</span>
        <span className="subtitle">Team replies instantly</span>
      </div>

      {isLoading ? <div className="loader-div"><span class="chatloader"></span></div> : !threadId && <div className="threads-div">
        {(threads?.length && !threadId) ? threads.map(thread => (
          <div className='thread' onClick={() => {
            fetchMessages(thread.threadId);
          }} style={{ position: 'relative' }} key={thread.threadId}>
            <div className="threaddetails">
              <span className="threadid" style={{ color: 'black' }}>#{thread?.threadId?.slice(-6)}</span>
              <span className="threadsample">{thread?.lastMessage?.content?.slice(0, 34)}...</span>
              <span className="lastmessageDate">{formatLastMessageTime(thread?.lastMessage?.timestamp)}</span>
            </div>
          </div>
        )) : <div className="loader-div"><button style={{
          padding: "10px 20px",
          borderRadius: "50px",
          fontSize: "13px",
          background: "#f0cd17",
          fontWeight: 600,
          color: "#1b2d8e",
          cursor: 'pointer',
          border: "none",
          outline: "none",
        }} onClick={() => {
          createThread();
        }}>+ Start New Conversation</button></div>}
        {!!threads?.length && <div style={{
          position: "absolute",
          bottom: "15px",
          width: "100%",
          textAlign: "center",
        }}>
          <button style={{
            padding: "10px 20px",
            borderRadius: "50px",
            fontSize: "13px",
            background: "#f0cd17",
            fontWeight: 600,
            color: "#1b2d8e",
            cursor: 'pointer',
            border: "none",
            outline: "none",
          }} onClick={() => {
            createThread();
          }}>+ Start New Conversation</button>
        </div>}
      </div>}
      {threadId && <div className=" chat-div">
        <div className={`inner-div`}>
          {inputDisabled && messages[messages?.length - 1]?.role !== "user"
            ? messages
              .filter((m, i) => i >= 0 && i !== messages.length - 1)
              .map((msg, index) => (
                <Message key={index} role={msg.role} text={msg.text} />
              ))
            : messages
              .filter((m, i) => i >= 0)
              .map((msg, index) => (
                <Message key={index} role={msg.role} text={msg.text} />
              ))}
          {inputDisabled && <Message key={Math.random()} role="loading" />}
          <div ref={messagesEndRef} />
        </div>
        <form
          onSubmit={handleSubmit}
          className={` inputForm`}
        >
          <input
            type="text"
            className="chat-input"
            value={userInput}
            style={{ marginRight: "10px" }}
            onChange={e => setUserInput(e.target.value)}
            placeholder="Enter your question"
          />
          <button
            type="submit"
            className="send-button"
            disabled={inputDisabled}
          >
            <img
              src={sendImage}
              alt=""
              style={{ width: "1.5rem", height: "1.5rem" }}
            />
          </button>
        </form>
      </div>}

    </div>
  )
}

export default Chat
